import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Store} from '@ngxs/store';
import {
  DashboardViewRegionsState
} from '../../../dashboard-view-regions/states/dashboard-view-regions/dashboard-view-regions.state';
import {AsyncPipe, NgOptimizedImage} from '@angular/common';
import {DashboardState} from '../../../dashboard-new/states/dashboard/dashboard.state';
import {DashboardUserSex} from '../../../dashboard-new/types/dashboard.types';
import {
  DashboardStudyDataViewComponent
} from '../dashboard-study-data-view/dashboard-study-data-view.component';

@Component({
  selector: 'app-dashboard-study-data-zone',
  templateUrl: './dashboard-study-data-zone.component.html',
  styleUrls: ['./dashboard-study-data-zone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NgOptimizedImage, DashboardStudyDataViewComponent],
})
export class DashboardStudyDataZoneComponent {
  public readonly dashboardUser$ = this.store.select(DashboardState.dashboardUser);
  public readonly lastSelectedViewRegion$ = this.store.select(DashboardViewRegionsState.selectedViewRegion);

  public readonly dashboardUserSex = DashboardUserSex;

  constructor(private store: Store) {}
}
